import React , {useEffect}  from 'react'
import {Routes,Route} from 'react-router-dom'
import './App.css'



import PageNotFound from './components/pages/pageNotFound'
import Comedy from './components/pages/index'
import ComedyHome from './components/pages/comedyHome/index'
import ComedyContentsCat from './components/pages/ComedyContentsCatPage'
import ComedyGalleriesCat from './components/pages/ComedyContentsCatPage/galleriesContentsPage'
import ComedyVideosList from './components/pages/comedyVideosList'
import ComedyStoriesSerials from './components/pages/comedyStoriesSerialsPage'
import ComedyVideoDetails from './components/pages/comedyVideoDetailsPage'
import ComedyContent from './components/pages/comedyContent'
import ComedyPicture from './components/pages/comedyContent/pictures'
import AdSenseLoader from './components/common/AdSenseLoader'

      function App({data}) {
     
             let isMobile = data?.[1]?.isMobile || false


        
         useEffect(() => {
    /* Disable right click */
    const handleContextMenu = (e) => {
      e.preventDefault()
    }

    /* Disable copy, cut, paste */
    const handleCopy = (e) => e.preventDefault()
    const handleCut = (e) => e.preventDefault()
    const handlePaste = (e) => e.preventDefault()

    /* Disable keyboard shortcuts (Ctrl+C, Ctrl+V, Ctrl+X, Ctrl+S, Ctrl+U) */
    const handleKeyDown = (e) => {
      if (
        (e.ctrlKey || e.metaKey) &&
        ['c', 'v', 'x', 's', 'u'].includes(e.key.toLowerCase())
      ) {
        e.preventDefault()
      }
    }

    document.addEventListener('contextmenu', handleContextMenu)
    document.addEventListener('copy', handleCopy)
    document.addEventListener('cut', handleCut)
    document.addEventListener('paste', handlePaste)
    document.addEventListener('keydown', handleKeyDown)

    /* Disable image drag */
    const disableImageDrag = () => {
      document.querySelectorAll('img').forEach((img) => {
        img.setAttribute('draggable', 'false')
      })
    }

    disableImageDrag()

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu)
      document.removeEventListener('copy', handleCopy)
      document.removeEventListener('cut', handleCut)
      document.removeEventListener('paste', handlePaste)
      document.removeEventListener('keydown', handleKeyDown)
    }
          }, [])



        
      return (

            <main className="App d-flex flex-column align-items-center">

            <AdSenseLoader />
            <Routes>
                  
                  <Route path="/" element={<Comedy isMobile={isMobile}  />}  >
                       <Route  index element={<ComedyHome  data={data} />} /> 
                       <Route path="contents/:cat" element={<ComedyContentsCat data={data}   />} />
                       <Route path="galleries/Chitti-Archive-11-1.html" element={<ComedyGalleriesCat data={data}  />} />
                        <Route path="videoslist/:video" element={<ComedyVideosList data={data} /> } />
                        <Route path="storiesserials.html" element={<ComedyStoriesSerials data={data} />} />
                         <Route path="videodetails/:name" element={<ComedyVideoDetails data={data} />} />
                        <Route path="content/:name" element={<ComedyContent data={data} />} /> 
                        <Route path="pictures/:name" element={<ComedyPicture data={data} />} />        
                  </Route>
                  <Route path="*" element={<PageNotFound />} />
            </Routes>
            </main>
      )


      }

export default App;